"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSVG = exports.SVG = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.SVG = styled_components_1.default.svg.attrs({
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink',
}) ``;
exports.StyledSVG = (0, styled_components_1.default)(exports.SVG) `
  width: ${({ width, fullWidth }) => (fullWidth ? '100%' : width !== null && width !== void 0 ? width : 'auto')};
  height: ${({ height }) => height !== null && height !== void 0 ? height : 'auto'};
  ${({ customStyles }) => customStyles || {}}
`;
//# sourceMappingURL=styles.js.map